import React, { useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import Table from 'components/customTable';

import ZpFilter from '../../../components/zpFilter';
import { CAROUSEL_FILTERS,FILTER_PARAMS } from '../../../components/zpFilter/filterUtils';
import CommonService from '../../../services/commonService';
import { JOB_BUCKET_GROUP } from '../../../utils/constant';
import HorizontalBarChart from '../charts/horizontalBarChart';

const xAxisLabels = ['0%', '20%', '40%', '60%', '80%', '100%'];

const AgeBreakdown = ({
  jobTitle,
  ages,
  ageBreakDownContentBlurb,
  filterValueRange,
  filterLogEventCallback,
}) => {
  const yAxisLabels = ages.map(({ age }) => age);
  const values = ages.map(({ agePercent }) => agePercent);
  const [compareJobTitle, setCompareJobTitle] = useState('');
  const [compareValues, setCompareValues] = useState([]);
  const tableData = (ages ?? []).map((x) => ({
    ...x,
    agePercentDisplay: x.agePercent + '%',
  }));

  const handleFilterUpdate = async (_, data) => {
    const { value = jobTitle } = data;
    const ageBreakdownByTitle = value.originalSearch ? value.originalSearch : value;

    try {
      if (ageBreakdownByTitle === jobTitle && _isEmpty(compareValues)) {
        return;
      } else if (ageBreakdownByTitle === jobTitle && !_isEmpty(compareValues)) {
        setCompareJobTitle('');
        setCompareValues([]);
        return;
      }

      const data = {
        jobTitles: [ageBreakdownByTitle],
      };

      const newAges = await CommonService.fetchTitleAgeBreakdownData(data);
      const newValues = newAges[0].range.map(({ agePercent }) => agePercent);

      setCompareJobTitle(data.jobTitles[0]);
      setCompareValues(newValues);
    } catch (error) {
      console.log(error);
    }
  };

  const filterProps = () => {
    return {
      ...CAROUSEL_FILTERS[FILTER_PARAMS.JOB_TITLE],
      buttonText: 'Compare Jobs',
      valueRange: filterValueRange,
      onApply: handleFilterUpdate,
      onClear: handleFilterUpdate,
      options: {
        logEvent: () =>
          filterLogEventCallback(JOB_BUCKET_GROUP.CAREER_DEMOGRAPHICS_COMPARE_AGE_BREAKDOWN),
      },
    };
  };

  return (
    <section id="age-breakdown-section">
      <div className="section-separator-medium" />

      <h3 className="cmpSectionh4 mb-3">{`${jobTitle} Age Breakdown`}</h3>

      {ageBreakDownContentBlurb && ageBreakDownContentBlurb.content && (
        <div dangerouslySetInnerHTML={{ __html: ageBreakDownContentBlurb.content }} />
      )}

      <div className="mt-4">
        <ZpFilter {...filterProps()} />
        <div className="mt-4">
          <HorizontalBarChart
            values={values}
            jobTitle={jobTitle}
            xAxisLabels={xAxisLabels}
            yAxisLabels={yAxisLabels}
            compareValues={compareValues}
            compareJobTitle={compareJobTitle}
            yAxisLabelsWidth="136px"
            tooltipKey="diveristy-age-breakdown"
          />
        </div>
        <br />
        <div className="mb-0 z-mt-48">
          <Table
            columnConfig={{
              age: {
                columnName: jobTitle + ' Years',
              },
              agePercentDisplay: {
                columnName: 'Percentages',
                customSortByField: 'agePercent',
                // defaultSortDirection: 'desc'
              },
            }}
            bodyData={tableData}
            defaultRowsDisplay={99}
            tableHeaderTitleContent={
              <h3 className="zp-title-h3 text-capitalize z-mb-24">{`${jobTitle} Age`}</h3>
            }
          />
        </div>
      </div>
    </section>
  );
};

AgeBreakdown.propTypes = {
  jobTitle: PropTypes.string.isRequired,
  ages: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AgeBreakdown;
